import { motion } from "framer-motion";
import { DraftingCompass, Crosshair, HardHat, Box } from "lucide-react";
import { useLang, STR } from "../i18n";

const ICONS = [DraftingCompass, Crosshair, HardHat, Box];

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

export const Services = () => {
  const { lang } = useLang();
  const t = STR[lang].services;

  return (
  <section id="servizi" className="bg-white pt-[75px] pb-[82px]" data-testid="services-section">
    <div className="max-w-[1320px] mx-auto px-6">
      <div className="grid lg:grid-cols-[1.35fr_repeat(4,1fr)] gap-10 lg:gap-0 lg:divide-x lg:divide-[#e3e7ea]">
        <motion.div {...reveal} className="lg:pr-10 flex flex-col justify-center">
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#F18A00] font-bold" data-testid="services-eyebrow">
            {t.eyebrow}
          </p>
          <h2 className="font-display font-medium text-[30px] uppercase tracking-[-0.02em] text-[#0D1B2A] mt-[7px]" data-testid="services-title">
            {t.title}
          </h2>
          <span className="block w-[38px] h-0.5 bg-[#F18A00] mt-[15px]" aria-hidden="true" />
          <p className="mt-6 text-sm text-[#66727b] leading-[1.65]" data-testid="services-intro">
            {t.intro}
          </p>
          <a
            href="#consulenze"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#consulenze")?.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid="services-all-button"
            className="group mt-8 inline-flex items-center justify-between gap-6 border border-[#0D1B2A] text-[#0D1B2A] px-6 py-4 text-xs uppercase tracking-[0.045em] hover:border-[#F18A00] hover:text-[#F18A00] transition-colors duration-300 self-start"
          >
            {t.all} <span className="text-[21px] font-light leading-none transition-transform duration-300 group-hover:translate-x-1">{"→"}</span>
          </a>
        </motion.div>

        {t.items.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={s.title}
              {...reveal}
              transition={{ ...reveal.transition, delay: 0.1 + i * 0.08 }}
              className="group text-center px-[30px] py-[35px] flex flex-col items-center justify-center"
              data-testid={`service-card-${i}`}
            >
              <div className="h-[92px] flex items-center justify-center mb-[22px]">
                <Icon size={54} strokeWidth={0.75} className="text-[#0D1B2A] group-hover:text-[#F18A00] transition-colors duration-300" />
              </div>
              <h3 className="text-sm uppercase font-medium text-[#0D1B2A] mb-[18px]" data-testid={`service-title-${i}`}>
                {s.title}
              </h3>
              <p className="text-xs leading-[1.65] text-[#68737b] max-w-[205px]" data-testid={`service-desc-${i}`}>
                {s.desc}
              </p>
            </motion.div>
          );
        })}
      </div>

      <motion.div {...reveal} id="consulenze" className="mt-16 border-t border-[#e3e7ea] pt-12" data-testid="consulenze-block">
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#F18A00] font-bold mb-8">{t.moreTitle}</p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10">
          {t.list.map((item, i) => (
            <li key={item} className="flex items-start gap-3 py-3 border-b border-[#edf0f2] text-sm text-[#4A4F55]" data-testid={`consulenza-item-${i}`}>
              <span className="mt-1.5 w-1.5 h-1.5 bg-[#F18A00] rotate-45 shrink-0" />
              {item}
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
  );
};
